import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202602",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 14999,
  clicks: 232,
  adsSpendDollars: 1393,
  budgetDollars: 1500,
  salesDollars: 12454,
  bestEstimateRoas: 8.94,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.93,
  newCustomersAcquired: 9,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
